var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pa-5"},[_c('v-progress-circular',{class:{ 'as-organization-style': _vm.isOrganizationPath },attrs:{"size":40,"width":5,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }